import type { ApiClient } from './client.js';

export interface SourceResponse {
  readonly lines: string[];
  readonly startLine: number;
  readonly endLine: number;
}

export interface GetNodeSourceOptions {
  readonly lines?: number;
  /** Optional branch override — server defaults to the registry's
   *  `defaultBranch` for the slug when omitted. Added in the 260525-1509 fix
   *  so the viewer reads via `git show <branch>:<path>` and is no longer
   *  dependent on the cloud worker's working-tree state. */
  readonly branch?: string;
}

export async function getNodeSource(
  api: ApiClient,
  slug: string,
  filePath: string,
  startLine: number,
  options: GetNodeSourceOptions = {},
): Promise<SourceResponse> {
  const params = new URLSearchParams({
    path: filePath,
    startLine: String(startLine),
    lines: String(options.lines ?? 40),
  });
  if (options.branch) params.set('branch', options.branch);
  return api.request<SourceResponse>(
    `/api/repos/${encodeURIComponent(slug)}/source?${params.toString()}`,
  );
}
